import { IconTeam } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const teamModule: ModuleDefinition = {
  id: 'team',
  i18nNamespace: 'team',
  requires: { subject: 'member', action: 'read' },

  nav: {
    labelKey: 'team:nav',
    icon: IconTeam,
    to: 'team',
    group: 'manage',
    order: 10,
  },

  routes: [{ path: 'team', component: () => import('./TeamPage') }],

  commands: [
    {
      id: 'team.invite',
      labelKey: 'team:invite',
      groupKey: 'team:title',
      requires: { subject: 'member', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/team?invite=1`),
    },
  ],
};
